import { Dialog, DialogConfig } from '@angular/cdk/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { ComponentType } from '@angular/cdk/portal';
import { Injectable } from '@angular/core';
import {
  DEFAULT_DIALOG_OPTIONS,
  DEFAULT_PREVIEW_OPTIONS,
  DEFAULT_SIDE_PANEL_OPTIONS,
} from '../constants/dialog.constants';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  private defaultDialogOptions = DEFAULT_DIALOG_OPTIONS;
  private defaultSidePanelOptions = DEFAULT_SIDE_PANEL_OPTIONS;
  private defaultPreviewOptions = DEFAULT_PREVIEW_OPTIONS;

  constructor(private dialog: Dialog, private overlay: Overlay) {}

  openDialog<T>(component: ComponentType<T>, componentOptions?: DialogConfig) {
    const options: any = this.mergeOptions(
      this.defaultDialogOptions,
      componentOptions
    );
    const dialog = this.dialog.open(component, options);

    return dialog.closed;
  }

  openSidePanel<T>(
    component: ComponentType<T>,
    componentOptions?: DialogConfig
  ) {
    const options: any = this.mergeOptions(
      this.defaultSidePanelOptions,
      componentOptions
    );
    const dialog = this.dialog.open(component, {
      ...options,
      positionStrategy: this.overlay.position().global().right('0').bottom('0'),
    });

    return dialog.closed;
  }

  openPreview<T>(component: ComponentType<T>, componentOptions?: DialogConfig) {
    const options: any = this.mergeOptions(
      this.defaultPreviewOptions,
      componentOptions
    );
    const dialog = this.dialog.open(component, options);

    return dialog.closed;
  }

  closeAll() {
    this.dialog.closeAll();
  }

  private mergeOptions(
    defaultOptions: DialogConfig,
    newInformation?: DialogConfig
  ) {
    return { ...defaultOptions, ...newInformation };
  }
}
